import { Injectable, signal } from '@angular/core'
import { StorageService, STORAGE_KEYS } from '@/services/storage.service'

const MAX_ENTRIES = 6

/** Search terms that returned at least one result, newest first. App-wide. */
@Injectable({ providedIn: 'root' })
export class RecentSearchesService {
	public readonly terms = signal<string[]>(StorageService.getOrDefault(STORAGE_KEYS.recentSearches))

	public add(term: string): void {
		const normalized = term.trim()
		if (!normalized) {
			return
		}

		const withoutDuplicate = this.terms().filter((entry) => entry.toLowerCase() !== normalized.toLowerCase())
		this.persist([normalized, ...withoutDuplicate].slice(0, MAX_ENTRIES))
	}

	public remove(term: string): void {
		this.persist(this.terms().filter((entry) => entry !== term))
	}

	public clear(): void {
		this.persist([])
	}

	private persist(terms: string[]): void {
		this.terms.set(terms)
		StorageService.set(STORAGE_KEYS.recentSearches, terms)
	}
}
